import { catchError as rxjscatchError, map as rxjsmap } from 'rxjs';
import {
  ApprovalNotices,
  PortalRisk,
  RiskAnalysisCategory
} from './../models/riskanalysis';

import { BaseServices } from './../../kuba.services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  Riskanalysis,
  Department,
  Topic,
  RiskanalysisActionPlan,
  TaskPlan
} from '../models/riskanalysis';

import { TreeData } from './../../common/models/index';
import { Category } from 'src/app/kuba/businesses/models';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services';

@Injectable()
export class RiskanalysisService {
  _topic: Observable<any> = null!;
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) {}
  clearCachedTopic() {
    this._topic = null!;
  }
  // list the risk analysis details
  list() {
    return this.http
      .get(environment.BASE_URL + '/riskbybusiness/' + BaseServices.BusinessId).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  deleteTaskPlan(Id: any) {
    return this.http
      .delete(environment.BASE_URL + '/activitydelete/' + Id).pipe(rxjsmap(result => result));
  }
  getAllByProj(id: number) {
    return this.http
      .get(environment.BASE_URL + '/riskanalysisbyproject/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  deleteRisk(id: any) {
    return this.http
      .delete(environment.BASE_URL + '/risanalysisdelete/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  deleteApprovalNotice(id: any) {
    return this.http
      .delete(environment.BASE_URL + '/riskanalysis/deleteapproved/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  // get the particular risk analysis
  getById(id: any) {
    if (id > 0) {
      let result: any = this.http
        .get(environment.BASE_URL + '/riskanalysis/' + id).pipe(rxjsmap((result: any) => result));
      return result;
    }
  }

  followupriskadd(data: Riskanalysis) {
    return this.http
      .post(environment.BASE_URL + '/followup/followup-riskanalysis', data).pipe(rxjsmap(result => result));
  }
  addPortalRisk(data: PortalRisk) {
    return this.http
      .post(environment.BASE_URL + '/riskforportal', data).pipe(rxjsmap(result => result));
  }
  update(data: any) {
    return this.http
      .put(environment.BASE_URL + '/riskanalysis/', data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  RiskBusinessupdate(data: any) {
    return this.http
      .post(environment.BASE_URL + '/riskbusinessdepartment', data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  updateRiskAnalysisAction(data: any) {
    return this.http
      .put(environment.BASE_URL + '/riskanalysis/', data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  addRiskAnalysisAction(newActionPlan: any) {
    return this.http
      .post(environment.BASE_URL + '/riskanalysis', newActionPlan).pipe(rxjsmap(result => result));
  }

  // update department in view
  updateDept(existingCategory: Department) {
    return this.http
      .put(
        environment.BASE_URL + '/department/' + existingCategory.Id,
        existingCategory
      ).pipe(rxjsmap(result => result));
  }

  // adding new department in view
  createDept(newCategory: Department) {
    return this.http
      .post(environment.BASE_URL + '/department/', JSON.stringify(newCategory)).pipe(rxjsmap(result => result));
  }

  createTopic(newCategory: Topic) {
    return this.http
      .post(environment.BASE_URL + '/Save/', JSON.stringify(newCategory)).pipe(rxjsmap(result => result));
  }
  deleteDepartement(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/departmentdelete/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  getTopicByBusiness(id: any) {
    if (!this._topic) {
      this._topic = this.http
        .get(environment.BASE_URL + '/DeviationTopic/' + id)
        .pipe(map(result => result));
    }
    return this._topic;
  }
  getTopicByBusinessIdForPortal(businessId: any) {
    
    var topic = this.http
      .get(environment.BASE_URL + '/DeviationTopic/' + businessId)
      .pipe(map(result => result));
    return topic;

  }
  getTopicByPortal(id: any) {
    if (!this._topic) {
      this._topic = this.http
        .get(environment.BASE_URL + '/DeviationTopicbyPortal/' + id)
        .pipe(map(result => result));
    }
    return this._topic;
  }
  updateTopic(existingCategory: Topic) {
    return this.http
      .put(environment.BASE_URL + '/Update/', existingCategory).pipe(rxjsmap(result => result));
  }
  DeleteTopic(id: any) {
    return this.http
      .delete(environment.BASE_URL + '/Delete/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  getByAnalysis(id: number) {
    return this.http
      .get(environment.BASE_URL + '/riskanalysistaskplan/' + id).pipe(rxjsmap(result => result));
  }

  addApprovalNotices(approvalNoticeIds: number[]) {
    return this.http
      .post(
        environment.BASE_URL + '/riskanalysis/approverisks',
        approvalNoticeIds
      ).pipe(rxjsmap(result => result));
  }

  getBusinesses() {
    // Use pagination with large page size to get all businesses
    const filter = {
      PageNumber: 1,
      PageSize: 10000, // Large number to get all businesses
      SortColumn: 'CompanyName',
      SortDirection: 'ASC'
    };

    return this.http
      .post<any>(environment.BASE_URL + '/businesses/paged', filter)
      .pipe(
        map((result: any) => result.Items || [])
      );
  }

  getApprovalNoticeByRisk(id: number) {
    return this.http
      .get(environment.BASE_URL + '/approvalnoticeByRisk/' + id)
      .pipe(
        map(result => {
          console.log(
            `Result for approval notice by risk (ID: ${id}):`,
            result
          );
          return result;
        })
      );
  }

  getApprovalNoticeByBusiness() {
    let result: any = this.http
      .get(
        environment.BASE_URL + '/approvalWithRisk/' + BaseServices.BusinessId
      ).pipe(rxjsmap((result: any) => result));
    return result;
  }

  getArchiveTree(businessId: number): Observable<TreeData[]> {
    return this.http
      .get(`${environment.BASE_URL}/archivetreedata/${businessId}`).pipe(rxjsmap((result: any) => result));
  }

  // add risk document from archive
  addriskdocument(riskAttachment: any) {
    return this.http
      .post(`${environment.BASE_URL}/add/riskdocument`, riskAttachment).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  getRiskAnalysisLog(analysisId: number) {
    return this.http
      .get(`${environment.BASE_URL}/riskanalysislog/${analysisId}`).pipe(rxjsmap((result: any) => result));
  }

  getRiskAnalysisForAdmin(applicationId: number, businessId: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/riskforadmin/${applicationId}/${businessId}`
      ).pipe(rxjsmap((result: any) => result));
  }

  getRiskAttachmentByRisk(riskId: number) {
    return this.http
      .get(`${environment.BASE_URL}/riskanalysisattachment/${riskId}`).pipe(rxjsmap((result: any) => result));
  }

  deleteRiskAttachment(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/risanalysisattachmentdelete/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  getUserForAdminRisk(riskId: number) {
    return this.http
      .get(environment.BASE_URL + '/usersforadmin/' + riskId).pipe(rxjsmap(result => result));
  }
  checkAllocatedDepartment(departmentID: number) {
    return this.http
      .get(environment.BASE_URL + '/checkdepartmentforrisk/' + departmentID).pipe(rxjsmap(result => result));
  }
  checkAllocatedTopic(topicId: number) {
    return this.http
      .get(environment.BASE_URL + '/checktopicforrisk/' + topicId).pipe(rxjsmap(result => result));
  }

  deleteApprovalnoticeList(data: any) {
    return this.http
      .put(environment.BASE_URL + '/deleteapproved/all', data).pipe(rxjsmap(result => result));
  }

  portalList(businessId: number) {
    return this.http
      .get(environment.BASE_URL + '/riskbybusinessforPortal/' + businessId).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  getPortalRiskAnalysis(userId: number) {
    return this.http
      .get(environment.BASE_URL + '/portalriskanalysis/' + userId).pipe(rxjsmap(result => result));
  }

  riskAnalysisReportGenerate(
    businessId: number,
    riskanalysisId: number,
    cultureInfo: string,
    ReportJson: any,
    FeatureId: number,
    userId: number,
    isEdit: boolean
  ) {
    let dynamicType = 'application/pdf';
    let myData = JSON.stringify({ data: ReportJson });
    let url = `${environment.BASE_URL}/export-RiskanalysisPrintDetails/${businessId}/${riskanalysisId}/${cultureInfo}/${FeatureId}/${userId}/${isEdit}`;
    let crfToken = this.authenticationService.getCsrfToken();
    return Observable.create(observer => {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Logo-Id', 'ab064fd4-9b4a-4e70-972d-dafdaceb2aba');
      xhr.setRequestHeader('X-XSRF-TOKEN', crfToken);
      xhr.responseType = 'blob';
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            let contentType = dynamicType;
            let blob = new Blob([xhr.response], { type: contentType });
            observer.next(blob);
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.send(myData);
    });
  }

  sendRiskMail(objMailInformation: any) {
    return this.http
      .post(environment.BASE_URL + '/sendRiskMail/', objMailInformation).pipe(rxjsmap(result => result));
  }

  //add category
  createCategory(newCategory: RiskAnalysisCategory) {
    return this.http
      .post(
        environment.BASE_URL + '/Category/Save/' + BaseServices.BusinessId,
        newCategory
      ).pipe(rxjsmap(result => result));
  }

  //get category list
  getCategoryList(BusinessId: number, ApplicationId: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/get/CategoryName/${ApplicationId}/${BusinessId}`
      ).pipe(rxjsmap((result: any) => result));
  }

  //delete category by Id
  DeleteCategoryById(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/delete/Category/' + Id).pipe(rxjsmap(result => result));
  }

  getDepartmentsForAdmin(riskId: number) {
    return this.http.get(
      environment.BASE_URL + '/departmentforadmin/' + riskId
    );
    // .map(result => result.json());
  }

  //get category list
  getCategoryListForPortal(portalId: number) {
    return this.http
      .get(`${environment.BASE_URL}/categoryList/${portalId}`).pipe(rxjsmap((result: any) => result));
  }
}
